import { FC, useMemo } from 'react';
import { Grid, IconButton, Typography } from '@mui/material';
import DialogModal from 'components/modal/dialog-modal';
import Tag from '../../../../tag';
import { IPost } from '_interfaces/post.interface';
import { IProject } from 'redux-store/api/projects';
import { ITag } from 'redux-store/types';
import CloseIcon from 'assets/icons/close.svg';
import { tagsModalStyles } from './styles';

interface ITagsModalProps {
  open: boolean;
  closeModal: () => void;
  post: IPost;
  project: IProject | null;
}

const TagsModal: FC<ITagsModalProps> = ({ closeModal, open, post, project }) => {
  const tags: ITag[] = useMemo(() => {
    const phases = (post.phaseIds || [])
      .map((id) => {
        const phase = project?.phases?.find((p) => p.id === id);
        return phase ? { id: phase.id, title: phase.title, color: phase.color } : null;
      })
      .filter(Boolean) as ITag[];

    const phaseItems = (post.phaseItemIds || [])
      .map((id) => {
        for (const phase of project?.phases || []) {
          const item = phase.items?.find((i) => i.id === id);
          if (item) return { id: item.id, title: item.title };
        }
        return null;
      })
      .filter(Boolean) as ITag[];

    return [...phases, ...phaseItems];
  }, [post.phaseIds, post.phaseItemIds, project?.phases]);

  return (
    <DialogModal open={open} handleClose={closeModal} maxWidth="800" withoutPadding>
      <Grid sx={tagsModalStyles.container}>
        <Grid sx={tagsModalStyles.header}>
          <Typography sx={tagsModalStyles.title}>Tags</Typography>
          <Grid sx={tagsModalStyles.closeButtonContainer}>
            <IconButton sx={tagsModalStyles.closeButton} onClick={closeModal}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
        <Grid sx={tagsModalStyles.postContainer}>
          <Grid sx={{ width: '100%', display: 'flex', flexFlow: 'row wrap', gap: '6px 8px' }}>
            {tags.map((tag) => (
              <Tag key={tag.id} option={tag} bgColor="#FFF" />
            ))}
          </Grid>
        </Grid>
      </Grid>
    </DialogModal>
  );
};

export default TagsModal;
